import React, {lazy, Suspense} from 'react';
import styled from "styled-components";
import {Spinner} from "../../helper/spinner";
import {useAtom} from "jotai";
import {modalPositionState, modalState} from "../../states/action";
import ModalHeader from "./Contents/ModalHeader";
import Draggable, {DraggableData, DraggableEvent} from "react-draggable";

type ModalBoxProps = {
  contentName: string
}


/**
 팝업 노출 (공지, 공유, 상품 리스트)

 * @param data1 설명
 * @return {data1} 반환
 * @throws ValidException 예외 발생
 * @author plaq99@rumpus.co.kr
 * @date 03-20-2023
 */

export default function ModalBox({contentName}: ModalBoxProps) {

  const [{modalOn}] = useAtom(modalState)
  const [{modalPositionX, modalPositionY}, setModalPosition] = useAtom(modalPositionState);

  // 동적 모달 콘텐츠 불러오기
  let ContentName = lazy(() => import(`./Contents/${contentName}`));

  const handleStop = (e:DraggableEvent, data: DraggableData ) => {
    const dragX = Math.abs(data.x - modalPositionX );
    const dragY = Math.abs(data.y - modalPositionY);
    if (dragX < 5 || dragY < 5) {
      e.stopPropagation();
    } else {
      setModalPosition({modalPositionX: data.x, modalPositionY: data.y});
    }
  }

  return (
    <>

      <ModalArea className={modalOn ? "on" : ""} id="modal_area">
        <Draggable
          defaultPosition={{x: modalPositionX, y: modalPositionY}}
          onStop={(e, data) => handleStop(e, data)}
          allowAnyClick={false}
        >
          <ModalWrapper>
            <ModalHeader/>
            <ModalContent>
              <Suspense fallback={Spinner()}>
                <ContentName/>
              </Suspense>
            </ModalContent>
          </ModalWrapper>
        </Draggable>
      </ModalArea>

    </>
  )
    ;
}


const ModalArea = styled.div`
  display: none;
  position: fixed;
  top: 0;
  right: 0;
  width: max-content;
  height: auto;
  z-index: 8888;
  /* bottom: 0; */
  /* left: 0; */
  /* z-index: 10000; */
  background-color: rgba(0, 0, 0, 0.6);

  &.on {
    display: block;
  }
`;

const ModalWrapper = styled.div`
  position: fixed;
  top: 10%;
  left: 10%;
  max-width: 80%;
  min-width: 40%;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  background-color: #2b2b2b;
  border: 3px solid #FF9800;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
`;


const ModalContent = styled.div`
  display: flex;
  justify-content: space-around;
  padding: 20px;
  background-color: #1a1a1a;
`;







